<template>
  <el-container class="ServiceSaleForm">  
    <el-main class="p-0">
      <el-form 
        ref="form" 
        label-width="80px" 
        class="form-label-80"
        :model="data" 
        :rules="rules" 
        inline 
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="담당자" prop="charger">
              <el-input v-model="data.charger" />
            </el-form-item>
          </el-col>  
          <el-col :span="6">
            <el-form-item :label="$t('lang.access_date')" prop="service_date">
              <ADatePicker
                :placeholder="$t('message.choose_date')"
                v-model="data.service_date"
              />
            </el-form-item>
          </el-col> 
          <el-col :span="6">
            <el-form-item label="설치일" prop="install_date">
              <el-input v-model="data.install_date" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="무상여부">
              <ACheckboxYN
                v-model="data.free_flag"
                prop="free_flag"
              />
            </el-form-item>
          </el-col>          
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="처리내용" prop="action">
              <el-input type="textarea" :rows="2" maxlength="100" v-model="data.action"></el-input>
            </el-form-item>
          </el-col>        
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
      >등록 (F4)</el-button>
      <!-- <div class="inline print-option ml-default">
        <el-select v-model="printOption">
          <el-option 
            v-for="o in printOptions"
            :key="o.value"
            :value="o.value"
          />
        </el-select>      
      </div>
      <el-button
        class="ml-default"
        @click="handleClickPrint"
      >인쇄</el-button> -->
      <el-button class="right" @click="handleClickClose">{{ $t("button.close") }}(Esc)</el-button>
    </el-footer>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="800px"
      :title="printOption"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      destroyOnClose
    >
      <ServicePrint
        ref="print"
        v-if="dialogVisible"
        :title="printOption"
        :data="data"
        @completed="handleCompletePrint"
      />
    </el-dialog>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";
// import ServiceCollect from "./ServiceCollect"
import ServicePrint from "./ServicePrint"
// import ContractForm from '@/spa/Sale/ContractForm'

export default {
  name: "ServiceSaleForm",  
  mixins: [form],  
  components: {/*ServiceCollect, */ServicePrint/*, ContractForm*/},
  data() {
    return {
      rules: {
        charger: [{ required: true, message: '담당자를 입력해 주세요.' }],
        service_date: [{ required: true, message: this.$t("message.choose_date") }],
        action: [{ required: true, message: "처리내용을 입력해 주세요." }],
      },
      items: [],
      sum: 0,
      activeTab: '1',
      currentCustomer: undefined,
      noTax: true,
      isChanged: false,
      dialogVisible: false,
      printOption: '견적서',
      contract: {
        id: 0,
        details: []
      },
    };
  }, 
  props: {    
    data: {
      type: Object,
      default: function() { return {}; }
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    data: function(val) {
      if (!val.customer_id) { return; }
      this.currentCustomer = this.table_customer.find(c => c.id === val.customer_id);
    },
  },
  destroyed() {
    if (!this.isChanged) { return; }
    this.$emit('completed', this.data);
  },
  computed: {
    ...mapGetters(["table_customer"]),
    printOptions() {
      return [
        { value: '견적서' },
        { value: '영수증' },
        { value: '거래명세표' },
      ]
    },
  },
  methods: {
    selectData() {
      this.api.selectContractByService(this.data.id).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
        }
      });
    },
    doRegister() {
      // const trades = this.$refs.trade.result();
      // const details = [];
      // for (let i = 0; i < trades.length; i++) {
      //   if (!trades[i].product_id && !trades[i].amount && !trades[i].cost) {
      //     continue;
      //   }
      //   let detail = Object.assign({}, trades[i]);
      //   if (!detail.price) { detail.price = 0 }
      //   if (!detail.tax) { detail.tax = null }
      //   detail.seq = i + 1;        
      //   details.push(detail);
      // }      
      let data = Object.assign({}, this.data);
      // data.price = this.sum;
      // data.details = details;

      this.api.updateService(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.$emit('completed', true)
      });
    },
    handleSelectCharger(u) {
      if (typeof (u) === 'string') {
        this.data.charger_user_id = null;
        this.data.charger_user_name = u;
      } else {
        this.data.charger_user_id = u.id;
        this.data.charger_user_name = u.name;
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    handleClickRegister() {
      this.$refs.form.validate(valid => {
        if (!valid) { return; }
        this.doRegister();
      });
    },
    handleCollectChange() {
      this.isChanged = true;
    },
    handleClickClose() {
      let data = undefined
      if (this.isChanged) {
        data = this.data;
      }
      this.$emit('completed', data);
      this.isChanged = false;
    },
    handleClickPrint() {
      this.dialogVisible = true;
    },
    handleCompletePrint() {
      this.dialogVisible = false;
    },
  }
};
</script>

<style lang="scss">
.ServiceSaleForm {
  .print-option { 
    padding: 0px 10px; 
    width: 120px; 
  }
}
</style>